export enum ProgramType {
  NotSet = 'NotSet',
  GetLeanAndFitGoal = 'GetLeanAndFitGoal',
  GainMuscleAndStrengthGoal = 'GainMuscleAndStrengthGoal',
  GetStrongAndFitGoal = 'GetStrongAndFitGoal',
  MobilityAndTone = 'MobilityAndTone',
  MuscleAndShred = 'MuscleAndShred',
}
